import { Vector } from "p5";
import * as THREE from "three";
import { seedBrush } from "../../../TypesAndConstants/const";
import { brushMinSizes } from "../../../TypesAndConstants/Brushes";
import {
  Animation,
  BackgroundImage,
  Dimension,
} from "../../../TypesAndConstants/types";
import { isSketchActive } from "../../SketchUtilities/isSketchActive";
import merge2Canvases from "../../SketchUtilities/MergeCanvas";
import { isSafari, isMobile } from "react-device-detect";
export class Three {
  scene: THREE.Scene | undefined;
  image: any[] = [];
  globalNoise: number = 0;
  isShape: boolean = false;
  renderer: THREE.WebGLRenderer | undefined;
  previewRenderer: THREE.WebGLRenderer | undefined;
  previewTexture: THREE.Mesh | undefined;
  previewCamera: any = {};
  previewScale: number = 0;
  initialBrush: number = seedBrush;
  isStreaming: boolean = false;
  streamingBackground = new THREE.Mesh();
  backgroundImages: BackgroundImage[] = [];
  historyPointer = 0;

  isMobile: boolean = false;
  doNotRender: boolean = false;
  hasInit: boolean = false;
  p5DrawStub?: () => void = undefined;
  p5DrawFill?: () => void = undefined;
  p5SelectColor?: () => void = undefined;
  drawTo2d?: () => void = undefined;
  initStreaming?: () => void = undefined;

  isColorfill = false;
  isColorSelect = false;
  isMobileMenuOpen = false;
  isImageMenuOpen = false;
  isMouseOnCanvas = false;
  currentColor: string = "";
  vec: THREE.Vector3[] = [];
  pos: THREE.Vector3[] = [];
  theta1 = 0;
  theta2 = 0;
  scaleTheta = 0;

  isCanvasTexture = false;
  animationMode: Animation = Animation.None;
  canvasTexture: any;

  vid: HTMLVideoElement = document.createElement("video");
  vidPlaybackRate: number = 0.1;

  offScreenVec = new THREE.Vector3(-1000000, -1000000, 500000);
  clock = new THREE.Clock();
  cube = new THREE.Mesh();
  trackingPlanes: THREE.Mesh[] = [];
  raycaster = new THREE.Raycaster();
  textures: THREE.Texture[] = [];
  loaderManager = new THREE.LoadingManager();

  loader = new THREE.TextureLoader(this.loaderManager);

  dim: { width: number; height: number } = { width: 0, height: 0 };
  camera: any = {};
  context: WebGLRenderingContext | null = null;
  currentTexture: number = -1;
  arraySize = 16;
  animateFlag = false;
  color = "";
  isPressed = false;
  brushCount = 0;
  brushSize = 0;
  opacity = 1;
  strobeCounter = 0;

  isOnCanvas: boolean = true;

  handleClearThetas = () => {
    this.theta1 = 0;
    this.theta2 = 0;
    this.scaleTheta = 0;
  };

  setAlphaTexture = (texture: number, forceRender: boolean = false) => {
    if (this.currentTexture === texture && !forceRender) return;
    this.handleClearThetas();
    this.setCurrentTexture( texture );
    if ( this.isTextureImage( this.currentTexture ) ) {
      const t = this.textures[texture];

      this.trackingPlanes.forEach((item) => {
        var mat = item.material as THREE.MeshBasicMaterial;
        mat.needsUpdate = true;
        mat.alphaTest = 0.05;
        mat.alphaMap = t;
      });
    } else {
      this.loadSWF(texture);
    }
  };

  setCurrentTexture = ( texture: number ) => {
    this.currentTexture = texture;
  }

  isTextureImage = ( texture: number )=> {
    return ( texture % 1 === 0 );
  }

  
  setOpacity = (opacity: number) => {
    this.opacity = opacity;
    this.trackingPlanes.forEach((item, index) => {
      var mat = item.material as THREE.MeshBasicMaterial;
      mat.opacity = this.opacity;
    });
  };

  getMinimumSize = ( texture: number ) => {
    return brushMinSizes[ this.currentTexture ] || 0;
  }

  setBrushSize = (s: number) => {
    const minimumSize = this.getMinimumSize( this.currentTexture );
    const size =(Math.max( minimumSize, s )) / 1000;
    if (this.brushSize !== size) {
      this.brushSize = size;
      this.trackingPlanes.forEach((item) => {
        item.scale.set(size, size, size);
      });
    }
  };

  loadMp4 = (texture: number) => {
    switch (parseFloat(texture as any)) {
      case 1.1:
        return require("../../../../Assets/helixx.mp4");
      case 1.2:
        return require("../../../../Assets/bird.mp4");
      case 1.3:
        return require("../../../../Assets/blink.mp4");
      case 1.4:
        return require("../../../../Assets/dust.mp4");
      case 1.5:
        return require("../../../../Assets/burst.mp4");
      case 1.6:
        return require("../../../../Assets/noise.mp4");
      case 1.7:
        return require("../../../../Assets/cube3D.mp4");
      case 1.8:
        return require("../../../../Assets/wireframe.mp4");
      case 1.9:
        return require("../../../../Assets/droplet.mp4");
      case 1.11:
        return require("../../../../Assets/Noisey Droplet.mp4");
      case 1.12:
        return require("../../../../Assets/asteroid.mp4");
      case 1.13:
        return require("../../../../Assets/flower.mp4");
      case 1.14:
        return require("../../../../Assets/neogeo.mp4");
      case 1.15:
        return require("../../../../Assets/ll.mp4");
      case 1.16:
        return require("../../../../Assets/extraLava.mp4");
      case 1.17:
        return require("../../../../Assets/Donut.mkv");
      case 1.18:
        return require("../../../../Assets/donuts.mkv");
      default:
        return "";
    }
  };

  setPlaybackRate = (playbackRate: number) => {
    this.vidPlaybackRate = playbackRate;
    this.vid.playbackRate = playbackRate;
  };

  loadSWF = (index: number) => {
    this.doNotRender = true;
    this.vid.src = this.loadMp4(index);
    this.vid.load();
    this.vid.playbackRate = this.vidPlaybackRate;
    const promise = this.vid.play();
    if (promise) {
      promise.then(() => {
        this.doNotRender = false;
        this.canvasTexture = new THREE.VideoTexture(this.vid);
        this.canvasTexture.needsUpdate = true;
        if (this.previewTexture) {
          var previewMat = this.previewTexture!
            .material as THREE.MeshBasicMaterial;
          previewMat.alphaMap = this.canvasTexture;
        }
        this.trackingPlanes.forEach((item, index) => {
          var mat = item.material as THREE.MeshBasicMaterial;
          mat.alphaMap = this.canvasTexture;
          mat.needsUpdate = true;
          mat.alphaTest = 0.05;
        });
      });
    }
    this.vid.onplaying = () => {};
  };

  setTexture = (index: number, brushSize: number) => {
    this.setAlphaTexture(index);
    this.setBrushSize(brushSize);
  };

  setColor = (color: string) => {
    const colorInt = parseInt(color.replace(/^#/, ""), 16);
    const prevMat = this.previewTexture!.material as THREE.MeshBasicMaterial;
    prevMat.color.setHex(colorInt);
    this.trackingPlanes.forEach((item, index) => {
      var mat = item.material as THREE.MeshBasicMaterial;
      mat.color.setHex(colorInt);
    });
  };

  fill = () => {
    if (this.p5DrawFill) {
      this.p5DrawFill();
    }
  };

  selectColor = () => {
    if (this.p5SelectColor) {
      this.p5SelectColor();
    }
  };

  clear = () => {
    if (this.renderer) {
      this.renderer!.clear();
    }
  };

  handleResolutionSwitch = () => {
    this.clear();
    this.backgroundImages = [];
  };

  mouseRelease = (isOnCanvas: boolean) => {
    this.trackingPlanes.forEach((item) => {
      item.position.copy(this.offScreenVec);
    });
    this.isPressed = false;
    if (
      this.isMobile ? !this.isMobileMenuOpen && isOnCanvas : isSketchActive()
    ) {
      this.generalAddToHistory();
    }
  };

  setMouseCoords = (loc: Vector[]) => {
    loc.forEach((item, index) => {
      this.pos[index].copy(new THREE.Vector3(item.x, item.y, 0));
    });
  };

  setPreviewTexture = (texture: number) => {
    let t = undefined;
    if ( this.isTextureImage( texture )) {
      t = this.textures[texture]; // Set Brush Preview
      if (this.previewTexture) {
        var previewMat = this.previewTexture
          .material as THREE.MeshBasicMaterial;
        previewMat.alphaMap = t;
      }
    }
  };

  setAnimationMode = (mode: number) => {
    this.theta1 = 0;
    this.theta2 = 0;
    this.scaleTheta = 0;
    this.rotateCounter = 0;
    this.animationMode = mode;
    this.previewTexture!.position.x = 0;
    this.previewTexture!.position.y = 0;
    this.previewTexture!.rotation.x = 0;
    this.previewTexture!.rotation.y = 0;
    this.previewTexture!.rotation.z = 0;
    this.previewTexture!.scale.set(
      this.previewScale,
      this.previewScale,
      this.previewScale
    );

    this.clearAllRotations();
  };

  setPreviewScale = (s: number) => {
    this.previewScale = s;
    this.previewTexture!.scale.set(
      this.previewScale,
      this.previewScale,
      this.previewScale
    );
  };

  clearAllRotations = () => {
    this.trackingPlanes.forEach((item) => {
      (item as THREE.Mesh).rotation.x = 0;
      (item as THREE.Mesh).rotation.y = 0;
      (item as THREE.Mesh).rotation.z = 0;
    });
  };

  updateCamera = (d: Dimension) => {
    if (this.renderer === undefined) return;
    const aspect = d.width / d.height;
    const change = this.dim.width / this.dim.height / aspect;
    const newSize = 2 * change;
    this.camera.left = (-aspect * newSize) / 2;
    this.camera.right = (aspect * newSize) / 2;
    this.camera.top = newSize / 2;
    this.camera.bottom = -newSize / 2;

    this.camera.updateProjectionMatrix();
    this.dim = d;
    this.renderer.setSize(d.width, d.height);
    //this.backgroundImages.pop()
  };

  initTextures = () => {
    this.image[0] = require("../../../../Assets/basic.jpg");
    this.image[1] = require("../../../../Assets/square.jpg");
    this.image[2] = require("../../../../Assets/star.jpg");
    this.image[3] = require("../../../../Assets/softCircle.jpg");
    this.image[4] = require("../../../../Assets/voroni.jpg");
    this.image[5] = require("../../../../Assets/chain.jpg");
    this.image[6] = require("../../../../Assets/hair-01.jpg");
    this.image[7] = require("../../../../Assets/leaf.jpg");
    this.image[8] = require("../../../../Assets/diamond.jpg");
    this.image[9] = require("../../../../Assets/splatter.jpg");
    this.image[10] = require("../../../../Assets/brushy.jpg");
    this.image[11] = require("../../../../Assets/Grid.jpg");
    this.image[12] = require("../../../../Assets/squareOutline.jpg");

    this.image[100] = require("../../../../Assets/transparent.jpg");
    THREE.ImageUtils.crossOrigin = "";

    return new Promise((resolve, reject) => {
      resolve(async () => {
        this.image.forEach((i, index) => {
          this.loader.load(i, (e) => {
            this.textures[index] = e;
          });
        });
        return;
      });
    });
  };

  handleStreaming = (isStreaming: boolean) => {
    this.isStreaming = isStreaming;
    if (isStreaming) {
      this.initStreaming!();
    }
  };

  getImagesforBlend = () => {
    return this.backgroundImages.map((i) => {
      return i.image;
    });
  };

  getImagesforPost = () => {
    return this.backgroundImages.map((i) => {
      return i.image.currentSrc.split(",")[1];
    });
  };
  mountPreviewMobile = ()=> {
    const previewEl = document.getElementById(
      "previewCanvasMobile"
    ) as HTMLCanvasElement;

    if (this.previewRenderer && previewEl) {
      previewEl.appendChild(this.previewRenderer.domElement);
    }
  }

  mountPreview = () => {
    const previewEl = document.getElementById(
      "previewCanvas"
    ) as HTMLCanvasElement;

    if (this.previewRenderer && previewEl) {
      previewEl.appendChild(this.previewRenderer.domElement);
    }
  };
  /**
   * Used only when the brush is switched from shape to another brush to preserve drawing order.
   */
  flattenCanvasAndSetAsDisplkay = (cb: (img: BackgroundImage) => void) => {
    var image = new Image();
    image.onload = () => {
      const imgHTML: BackgroundImage = {
        image,
        id: 0,
      };
      cb(imgHTML);
    };
    const img = merge2Canvases();
    if (img) {
      image.src = img;
    }
  };

  counter = 0;
  generalAddToHistory = () => {
    var image = new Image();
    image.onload = () => {
      this.backgroundImages[this.historyPointer] = {
        image: image,
        id: this.counter,
      };
      this.historyPointer++;
    };
    this.counter++;
    const img = merge2Canvases();
    if (img) {
      image.src = img;
    }
  };

  performUndo = () => {
    this.historyPointer--;
    this.clear();
    return this.backgroundImages[this.historyPointer - 1];
  };

  getCurrentImage = (): BackgroundImage => {
    return this.backgroundImages[this.historyPointer - 1];
  };

  getDownloadImage = () => {
    const image = merge2Canvases();
    if (image) {
      return image;
    }
  };

  getImageAsImageElement = () => {
    this.renderer!.domElement.toBlob((blob) => {
      if (blob) {
        const url = URL.createObjectURL(blob);
        var image = new Image();
        image.onload = () => {
          this.backgroundImages.push({
            image: image,
            id: this.backgroundImages.length,
          });
          URL.revokeObjectURL(url);
        };
        image.src = url;
      }
    });
  };

  setUpVid = () => {
    this.vid.id = "threeVideo";
    this.vid.width = 256;
    this.vid.height = 256;
    //this.vid.autoplay = true;
    this.vid.hidden = true;
    this.vid.loop = true;
    this.vid.muted = true;
    this.vid.playsInline = true;
    this.vid.style.cssText = isMobile
      ? "position:absolute,z-index:-100,display:none,transform:rotate(90deg)"
      : "position:absolute,z-index:-100,display:none";
    document.getElementById("splash2")!.appendChild(this.vid);
  };

  run = (dim: Dimension) => {
    this.setUpVid();
    this.dim = dim;
    const { width, height } = this.dim;

    this.scene = new THREE.Scene();
    var previewScene = new THREE.Scene();

    this.camera = new THREE.OrthographicCamera(
      width / -2,
      width / 2,
      height / 2,
      height / -2,
      0,
      100
    );

    const pWidth = 250;
    const pHeight = 250;

    this.previewCamera = new THREE.OrthographicCamera(
      pWidth / -2,
      pWidth / 2,
      pHeight / 2,
      pHeight / -2,
      0,
      100
    );

    this.previewCamera.aspect = 1;

    const safariConfig = {
      preserveDrawingBuffer: true,
      alpha: true,
    };

    const chromeConfig = {
      preserveDrawingBuffer: true,
      antialias: true,
      alpha: true,
    };

    this.renderer = new THREE.WebGLRenderer(
      isSafari ? safariConfig : chromeConfig
    );

    this.context = this.renderer!.getContext();
    this.renderer.setPixelRatio(window.devicePixelRatio);
    this.renderer.setSize(height, width);
    this.renderer.autoClear = false;
    this.renderer.autoClearColor = false;
    this.renderer.autoClearStencil = false;
    // this.renderer!.domElement.style.display = "none";
    this.previewRenderer = new THREE.WebGLRenderer({
      alpha: true,
    });

    this.previewRenderer.setPixelRatio(window.devicePixelRatio);
    this.previewRenderer.setSize(100, 100);

    const canvasEl = document.getElementById(
      "threeCanvas"
    ) as HTMLCanvasElement;
    if (canvasEl === null) return;
    this.renderer.domElement.id = "threeCanvasEl";
    canvasEl.appendChild(this.renderer.domElement);
    this.mountPreview();
    // baseMesh
    while (this.arraySize--) {
      this.vec.push(new THREE.Vector3());
      this.pos.push(new THREE.Vector3());

      var plane = new THREE.PlaneGeometry(10, 10);
      var material = new THREE.MeshBasicMaterial({
        alphaTest: 0.15,
        color: 0xff0000,
        transparent: true,
        side: THREE.DoubleSide,
      });

      var trackingPlane = new THREE.Mesh(plane, material);

      trackingPlane.position.copy(this.offScreenVec);
      this.scene.add(trackingPlane);
      if (this.arraySize === 1) {
        var prevPlane = new THREE.PlaneGeometry(100, 100);
        var prevMat = new THREE.MeshBasicMaterial({
          alphaTest: 0.15,
          transparent: true,
          side: THREE.DoubleSide,
        });
        this.previewTexture = new THREE.Mesh(prevPlane, prevMat);
        this.previewCamera.lookAt(this.previewTexture.position);
        previewScene.add(this.previewTexture);
      }
      this.trackingPlanes.push(trackingPlane);
      setTimeout(() => {
        this.updateCamera(dim);
        this.setPreviewTexture(this.initialBrush);
        this.setPreviewScale(2);
      }, 100);

      function fade(element: any) {
        var op = 1; // initial opacity
        var timer = setInterval(function () {
          if (op <= 0.1) {
            clearInterval(timer);
            element.style.display = "none";
          }
          element.style.opacity = op;
          element.style.filter = "alpha(opacity=" + op * 100 + ")";
          op -= op * 0.1;
        }, 50);
      }

      this.loaderManager.onLoad = () => {
        const el = document.getElementsByClassName("loadingScreen")![0];
        if (el) {
          fade(el);
        } else {
          return;
        }
        this.doNotRender = true;
        setTimeout(() => {
          document.getElementsByClassName("loadingScreen")![0].remove();
          this.setTexture(this.initialBrush, 25);
          this.setPreviewTexture(this.initialBrush);
          this.doNotRender = false;
        }, 500);
      };
      this.hasInit = true;
    }

    var getMouseCoords = () => {
      this.pos.forEach((item, index) => {
        this.vec[index].set(
          (item.x / this.dim.width) * 2 - 1,
          -(item.y / this.dim.height) * 2 + 1,
          0
        );
        this.vec[index].unproject(this.camera);
      });
    };

    const handleRotate = (mesh: THREE.Mesh, theta: number, XY?: number) => {
      if (this.rotateCounter > 360) {
        this.rotateCounter = 0;
      }
      this.rotateCounter = this.rotateCounter + 0.005;
      switch (XY) {
        case 0:
          mesh.rotation.x = theta;
          break;
        case 1:
          mesh.rotation.y = theta;
          break;
        default:
          mesh.rotation.z = theta;
          break;
      }
    };

    const handleSinTheta = (mesh: THREE.Mesh, isInPreview?: boolean) => {
      const size = isInPreview ? this.previewScale : this.brushSize;

      this.theta1 = this.theta1 + 0.0075;
      this.scaleTheta = size + (Math.sin(this.theta1) * size + size / 2);

      mesh.scale.set(this.scaleTheta, this.scaleTheta, this.scaleTheta);
    };

    const minSize = this.brushSize / 4;

    const handleScatter = (mesh: THREE.Mesh, isInPreview?: boolean) => {
      const size = isInPreview ? this.previewScale : this.brushSize;
      for (var x = 0; x < 2; x++) {
        var offsetX = (Math.random() * size - minSize) * 3;
        var offsetY = (Math.random() * size - minSize) * 3;

        if (isInPreview) {
          mesh.position.x = offsetX;
          mesh.position.y = offsetY;
        } else {
          mesh.position.x =
            offsetX > 0.5
              ? offsetX + mesh.position.x
              : offsetX - mesh.position.x;
          mesh.position.y =
            offsetY > 0.5
              ? offsetY + mesh.position.y
              : offsetY - mesh.position.y;
        }
      }
    };

    const handleSinRotate = (mesh: THREE.Mesh, isInPreview?: boolean) => {
      this.theta1 = this.theta1 + 0.0075;
      const size = isInPreview ? this.previewScale : this.brushSize;
      this.scaleTheta = size + (Math.sin(this.theta1) * size + size / 2);
      if (isInPreview) {
        mesh.rotateZ(this.scaleTheta / 30);
      } else {
        mesh.rotateZ(this.scaleTheta);
      }
    };

    const strobe = (mesh: THREE.Mesh, isInPreview?: boolean) => {
      if (this.globalNoise < 2.7) {
        mesh.position.x = -100000;
      } else {
        if (isInPreview) {
          mesh.position.x = 0;
        }
        this.strobeCounter = 0;
      }
    };

    const animationManager = (mesh: THREE.Mesh, isPreview?: boolean) => {
      switch (this.animationMode) {
        case Animation.Rotate:
          handleRotate(mesh, this.rotateCounter);
          break;
        case Animation.ROTATEX:
          handleRotate(mesh, this.rotateCounter, 0);
          break;
        case Animation.ROTATEY:
          handleRotate(mesh, this.rotateCounter, 1);
          break;
        case Animation.STROBE:
          this.strobeCounter = this.strobeCounter + 1;
          strobe(mesh, isPreview);
          break;
        case Animation.Scatter:
          handleScatter(mesh, isPreview);
          break;
        case Animation.Wavey_Size:
          handleSinTheta(mesh, isPreview);
          break;
        case Animation.Wavey_Rotate:
          handleSinRotate(mesh, isPreview);
          break;
        default:
          break;
      }
    };

    const brushManager = (x: number) => {
      const newVec = this.isOnCanvas ? this.vec[x] : this.offScreenVec;

      if (x < this.brushCount) {
        this.trackingPlanes[x].position.copy(newVec);
        this.trackingPlanes[x].rotation.z = isMobile ? 1.570796 : 0;
        if (this.animationMode !== -1) {
          animationManager(this.trackingPlanes[x]);
        }
      }
    };

    const drawTextures = () => {
      getMouseCoords();
      for (var x = 0; x < this.trackingPlanes.length - 1; x++) {
        brushManager(x);
      }
    };
    let reinit = true;

    const animate = () => {
      if (this.p5DrawStub) {
        this.p5DrawStub();
      }

      animationManager(this.previewTexture!, true);
      if (
        this.isPressed &&
        this.hasInit &&
        isSketchActive() &&
        !this.isShape &&
        !this.isColorfill &&
        !this.isColorSelect &&
        !this.isMobileMenuOpen &&
        !this.doNotRender
      ) {
        drawTextures();
      }

      if (
        !(this.trackingPlanes[0].material as THREE.MeshBasicMaterial)
          .alphaMap &&
        reinit
      ) {
        if ( !this.isTextureImage( this.initialBrush )) {
          this.loadSWF(this.initialBrush);
          reinit = false;
        } else {
          this.setAlphaTexture(this.initialBrush, true);
        }
      }

      requestAnimationFrame(animate);

      const prevMat = this.previewTexture!.material as THREE.MeshBasicMaterial;
      prevMat.needsUpdate = true;

      this.previewRenderer!.render(previewScene, this.previewCamera);
      if (this.isMouseOnCanvas) {
        this.renderer!.render(this.scene!, this.camera);
      }

      // if (this.drawTo2d) {
      //   this.drawTo2d();
      // }
    };

    animate();
  };
  rotateCounter: number = 1;
}
